'use client';

import React from 'react';
import Logo from "./Logo";
import Image from "next/image";
import Link from "next/link";
import { useState, useEffect } from 'react';

// Sosyal medya linkleri için tip tanımlaması
type SocialLink = {
  name: string;
  href: string;
  icon: string;
};

// Sosyal medya linklerini merkezi olarak tanımlama
const socialLinks: SocialLink[] = [
  {
    name: "Instagram",
    href: "https://instagram.com/fyn.wise",
    icon: "/images/instagram.png"
  },
  {
    name: "Facebook",
    href: "https://facebook.com/fynwise",
    icon: "/images/facebook.png"
  },
  {
    name: "Twitter",
    href: "https://twitter.com/fynwise",
    icon: "/images/twitter.png"
  },
  {
    name: "YouTube",
    href: "https://youtube.com/@fynwise",
    icon: "/images/youtube.png"
  },
  {
    name: "LinkedIn",
    href: "https://linkedin.com/company/fynwise",
    icon: "/images/linkedin.png"
  }
];

// Desktop versiyonu için komponent
function DesktopFooter() {
  return (
    <div className="relative mx-auto max-w-6xl px-4 sm:px-6">
      <div className="grid grid-cols-5 gap-6 md:gap-4 xl:gap-10">
        {/* Company Links */}
        <div className="space-y-2">
          <h3 className="text-lg font-bold text-white">Company</h3>
          <ul className="space-y-1 text-sm">
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/about"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/careers"
              >
                Careers
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/blog"
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/contact"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/faq"
              >
                FAQ
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/pricing"
              >
                Pricing
              </Link>
            </li>
          </ul>
        </div>

{/* Academy Links */}
<div className="space-y-2">
  <h3 className="text-lg font-bold text-white">Academy</h3>
  <ul className="space-y-1 text-sm">
    <li>
      <Link
        className="text-gray-400 hover:text-white transition"
        href="/academy#features"
      >
        Features
      </Link>
    </li>
    <li>
      <Link
        className="text-gray-400 hover:text-white transition"
        href="/academy#categories"
      >
        Courses
      </Link>
    </li>
    <li>
      <Link
        className="text-gray-400 hover:text-white transition"
        href="/academy#learning-path"
      >
        Learning Path
      </Link>
    </li>
  </ul>
</div>

        {/* Services Links */}
        <div className="space-y-2">
          <h3 className="text-lg font-bold text-white">Services</h3>
          <ul className="space-y-1 text-sm">
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/fynbot"
              >
                FynBot
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/simulation"
              >
                Dynamic Simulation
                </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/backtesting"
              >
                Advanced Backtesting
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/portfolio-optimization"
              >
                Portfolio Optimization
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/live-signals"
              >
                Live Signals
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/algorithmic-bots"
              >
                Algorithmic Bots
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal Links */}
        <div className="space-y-2">
          <h3 className="text-lg font-bold text-white">Legal</h3>
          <ul className="space-y-1 text-sm">
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/legal/privacy-policy"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/legal/terms-of-service"
              >
                Terms of Service
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/legal/cookie-policy"
              >
                Cookie Policy
              </Link>
            </li>
          </ul>
        </div>

{/* Logo ve Sosyal Medya Bölümü */}
<div className="flex flex-col items-center">
          <div className="mb-4">
            <Logo />
          </div>
          <div className="flex justify-center space-x-3">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-black border border-white/10 rounded-full w-8 h-8 flex items-center justify-center hover:border-white/30 transition-colors"
              >
                <Image
                  src={social.icon}
                  alt={social.name}
                  width={20}
                  height={20}
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Copyright Bölümü */}
      <div className="text-center mt-8 pt-4 border-t border-white/10">
        <p className="text-white text-sm">
          &copy; {new Date().getFullYear()} FynWise. All rights reserved.
        </p>
      </div>
    </div>
  );
}

// Mobil versiyon için komponent
function MobileFooter() {
  return (
    <div className="px-4">
      {/* Link Grupları */}
      <div className="grid grid-cols-4 gap-8">
        {/* Company */}
        <div className="space-y-3">
          <h3 className="text-base font-bold text-white">Company</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/about"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/careers"
              >
                Careers
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/blog"
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/contact"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/company/faq"
              >
                FAQ
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/pricing"
              >
                Pricing
              </Link>
            </li>
          </ul>
        </div>

{/* Academy */}
<div className="space-y-3">
  <h3 className="text-base font-bold text-white">Academy</h3>
  <ul className="space-y-2 text-sm">
    <li>
      <Link
        className="text-gray-400 hover:text-white transition"
        href="/academy#features"
      >
        Features
      </Link>
    </li>
    <li>
      <Link
        className="text-gray-400 hover:text-white transition"
        href="/academy#categories"
      >
        Courses
      </Link>
    </li>
    <li>
      <Link
        className="text-gray-400 hover:text-white transition"
        href="/academy#learning-path"
      >
        Learning Path
      </Link>
    </li>
  </ul>
</div>

        {/* Services */}
        <div className="space-y-3">
          <h3 className="text-base font-bold text-white">Services</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/fynbot"
              >
                FynBot
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/simulation"
              >
                Dynamic Simulation
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/backtesting"
              >
                Advanced Backtesting
                </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/portfolio-optimization"
              >
                Portfolio Optimization
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/live-signals"
              >
                Live Signals
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/services/algorithmic-bots"
              >
                Algorithmic Bots
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div className="space-y-3">
          <h3 className="text-base font-bold text-white">Legal</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/legal/privacy-policy"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/legal/terms-of-service"
              >
                Terms of Service
              </Link>
            </li>
            <li>
              <Link
                className="text-gray-400 hover:text-white transition"
                href="/legal/cookie-policy"
              >
                Cookie Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>

{/* Logo ve Sosyal Medya - Altta */}
<div className="flex flex-col items-center mt-8">
        <Logo />
        <div className="flex justify-center space-x-3 mt-4">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-black border border-white/10 rounded-full w-8 h-8 flex items-center justify-center hover:border-white/30 transition-colors"
            >
              <Image
                src={social.icon}
                alt={social.name}
                width={20}
                height={20}
              />
            </a>
          ))}
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center mt-8 pt-4 border-t border-white/10">
        <p className="text-white text-sm">
          &copy; {new Date().getFullYear()} FynWise. All rights reserved.
        </p>
      </div>
    </div>
  );
}

// Ana Footer komponenti
export default function Footer() {
  const [isMobile, setIsMobile] = useState(false);

  // Ekran boyutunu kontrol eden effect
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <footer className="bg-black text-white py-8 sm:py-8 relative">
      <Image
        src="/images/bg-features.png"
        alt="Background Pattern"
        fill
        className="absolute inset-0 object-cover opacity-25"
        style={{ zIndex: -1 }}
        priority
      />
      {isMobile ? <MobileFooter /> : <DesktopFooter />}
    </footer>
  );
}